module.exports = __webpack_public_path__ + "img/195.4bac8214.png";